// extracted by mini-css-extract-plugin
module.exports = {"image":"Auth_image__kPnhx","paper":"Auth_paper__3XNXa","lock-badge":"Auth_lock-badge__2lzff"};